import { DeviceFamily, DeviceTypeHelper, DeviceTypeIds } from '@ncss/models';
import { PropertyRow } from 'common';

export interface PropertyMarker {
  propertyId: string;
  marker: google.maps.marker.AdvancedMarkerElement;
  distanceFromMapCenter?: number;
  propertyRow?: PropertyRow;
}

export interface NetworkEquipmentMarker {
  propertyId: string;
  deviceId: number;
  marker: google.maps.marker.AdvancedMarkerElement;
}

export function GetEquipmentPinSrc(deviceId: number, isSelected: boolean) {
  const dt = DeviceTypeHelper.GetDeviceTypeBySerialNumber(deviceId);
  if (dt?.id === DeviceTypeIds.GATEWAY_201) {
    return `/map/gw201-pin${isSelected ? '-highlighted' : ''}.png`;
  }
  if (dt?.family === DeviceFamily.GATEWAY) {
    return `/map/gw4-pin${isSelected ? '-highlighted' : ''}.png`;
  }
  if (dt?.id === DeviceTypeIds.NL4) {
    return `/map/next-link-pin${isSelected ? '-highlighted' : ''}.png`;
  }
  return `/map/repeater-pin${isSelected ? '-highlighted' : ''}.png`;
}
